// Structured data para SEO - schema.org
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "HN Engenharia",
  "alternateName": "HN Engenharia Civil",
  "description": "Empresa líder em engenharia civil, especializada em projetos estruturais, consultoria técnica e gerenciamento de obras com qualidade e inovação.",
  "url": "https://hnengenharia.org",
  "logo": {
    "@type": "ImageObject",
    "url": "https://hnengenharia.org/logo512.png",
    "width": 512,
    "height": 512
  },
  "image": "https://hnengenharia.org/logo512.png",
  "foundingDate": "2020",
  "industry": "Engenharia Civil",
  "knowsAbout": [
    "Engenharia Civil",
    "Projetos Estruturais", 
    "Consultoria Técnica",
    "Gerenciamento de Obras",
    "Laudos Técnicos",
    "Projetos Arquitetônicos"
  ],
  "serviceArea": {
    "@type": "Country",
    "name": "Brasil"
  },
  "areaServed": "BR",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Atendimento ao Cliente",
    "availableLanguage": ["Portuguese", "pt-BR"],
    "telephone": "+55-11-99999-9999",
    "email": "contato@hnengenharia.org"
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "BR",
    "addressRegion": "Brasil"
  },
  "sameAs": [
    "https://www.linkedin.com/company/hnengenharia",
    "https://www.instagram.com/hnengenharia",
    "https://www.facebook.com/hnengenharia"
  ],
  "numberOfEmployees": {
    "@type": "QuantitativeValue",
    "value": "10-50"
  }
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Serviços de Engenharia Civil",
  "provider": {
    "@type": "Organization",
    "name": "HN Engenharia"
  },
  "description": "Oferecemos soluções completas em engenharia civil, incluindo projetos estruturais, consultoria técnica e gerenciamento de obras.",
  "areaServed": "Brasil",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Serviços de Engenharia",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Projetos Estruturais",
          "description": "Desenvolvimento de projetos estruturais completos para construções residenciais, comerciais e industriais."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Consultoria Técnica",
          "description": "Consultoria especializada em engenharia civil para análise e otimização de projetos."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Gerenciamento de Obras",
          "description": "Acompanhamento e gerenciamento completo de obras com controle de qualidade e prazos."
        }
      }
    ]
  }
};

export const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Início",
      "item": "https://hnengenharia.org"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Sobre",
      "item": "https://hnengenharia.org#sobre"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Serviços",
      "item": "https://hnengenharia.org#servicos"
    },
    {
      "@type": "ListItem",
      "position": 4,
      "name": "Contato",
      "item": "https://hnengenharia.org#contato"
    }
  ]
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Quais serviços a HN Engenharia oferece?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A HN Engenharia oferece soluções completas em engenharia civil, incluindo projetos estruturais, consultoria técnica, gerenciamento de obras, laudos técnicos e projetos arquitetônicos para construções residenciais, comerciais e industriais."
      }
    },
    {
      "@type": "Question",
      "name": "Como solicitar um orçamento para projeto estrutural?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Você pode solicitar um orçamento gratuito através do nosso formulário de contato no site ou entrando em contato diretamente conosco. Analisamos seu projeto e fornecemos uma proposta personalizada."
      }
    },
    {
      "@type": "Question",
      "name": "A HN Engenharia atende em todo o Brasil?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, atendemos projetos em todo o território nacional, oferecendo soluções completas em engenharia civil com qualidade e inovação."
      }
    },
    {
      "@type": "Question",
      "name": "Qual o prazo para entrega de projetos estruturais?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O prazo varia conforme a complexidade do projeto. Projetos residenciais simples podem ser entregues em 7-15 dias, enquanto projetos comerciais e industriais podem levar de 15-30 dias."
      }
    }
  ]
};
